import React from 'react';
import { Grid, Typography, Button, withStyles } from '@material-ui/core';

const TitleAndMetadata = ({ classes, title, numVideos, duration, onClickSeeAll }) => (
  <Grid container>
    <Grid item xs={12}>
      <Typography variant={'h6'}>{title}</Typography>
    </Grid>
    <Grid item xs={12}>
      <MetaData numVideos={numVideos} duration={duration} onClick={onClickSeeAll}/>
    </Grid>
  </Grid>
);

const styles = theme => ({});

export default withStyles(styles)(TitleAndMetadata);

const MetaData = ({ classes, numVideos, duration, onClick }) => (
  <Grid container alignItems={'center'}>
    <Grid item xs={6} md={4}>
      <Typography color={'textSecondary'} variant={'caption'}>
        {duration} | {numVideos} videos
      </Typography>
    </Grid>
    <Grid item xs={6} md={3}>
      <Button aria-label="SEE ALL" variant={'text'} color={'primary'} onClick={onClick}>
        SEE ALL
      </Button>
    </Grid>
  </Grid>
);
